import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import img from "../Assets/Teacher student-pana 2.png";
import Footer from "../Components/Footer";
import { loginUser } from "../Common/auth.js";
import Loader from "../Loader/Loader.jsx";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Aos from "aos";

function BeATrainer() {
  useEffect(() => {
          Aos.init({
            duration: 1000, // animation duration in ms
            once: true,     // animate only once
          });
        }, []);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    // name: "",
    // phone: "",
    password: ""
  });

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const { email, name, phone, password } = formData;

    if (!email || !password) {
      toast.error("All fields are required!");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Invalid email format!");
      return false;
    }

    // if (name.length < 3) {
    //   toast.error("Username must be at least 3 characters!");
    //   return false;
    // }

    // const phoneRegex = /^[6-9]\d{9}$/;
    // if (!phoneRegex.test(phone)) {
    //   toast.error("Invalid contact number! Must be 10 digits.");
    //   return false;
    // }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters!");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);
    try {
      const response = await loginUser(formData);
      console.log(response);
      if (response?.statusCode == 200) {
        const { user, token } = response?.data;
        localStorage.setItem("GISUL_USER", JSON.stringify(user));
        localStorage.setItem("GISUL_TOKEN", token);
        navigate("/");
      }
      toast.success("Login Successful!");
      setFormData({ email: "", password: "" });
    } catch (error) {
      toast.error(error?.response?.data?.message || "Signup failed!");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="main-div">
      <Navbar />
      {loading && <Loader />}
      <div className="New-login">
        <div className="New-login-left">
          <div className="flex flex-col md:gap-[16px] gap-[8px]">
            <div data-aos="fade-left" className="b1 b5">
              <h2>Become</h2>
            </div>
            <div data-aos="fade-left" className="b2 b6">
              <h2>A Trainer</h2>
            </div>
          </div>
          <div className="Register-div">
            {/* <p>If you don’t have an account register</p>
          <p>
            You can{" "}
            <Link to="/singup" style={{ color: "blueviolet" }}>
              Register here
            </Link>{" "}
            !!
          </p>
          <br /> */}
            <div className="cnt">
              <img data-aos="flip-up" src={img} />
            </div>
          </div>
        </div>

        <div className="New-login-right lg:!mr-[90px] !mr-auto lg:ml-0 ml-auto  max-w-[539px] w-full">
          <div data-aos="fade-left" className="max-w-[630px] w-full ml-auto bg-[rgb(255,255,255)] rounded-[16px] md:px-[40px] px-[20px] py-[20px] pb-[60px]">
            <div className="login-heading login-heading2 md:pb-[15px] pb-[34px]">
              <p>Apply For a <span> Trainer</span></p>
              {/* <h6>
              If you don’t have an account register
              <br />
              <Link to="/singup" style={{ color: "#075D9D" }}>
                Register here
              </Link>
            </h6> */}
            </div>
            {/* <h3>Login</h3> */}
            <div className="grid md:grid-cols-2 grid-cols-1 md:gap-x-[30px] gap-x-0 md:gap-y-[16px] gap-y-[20px]">
              <div className="flex col-span-2 flex-col gap-[5px]">
                <label className="form-label">Your Name</label>
                <input
                  className="form-input"
                  placeholder="Your Name"
                />
              </div>
              <div className="flex col-span-2 md:pt-0 pt-[0px] flex-col gap-[5px]">
                <label className="form-label">Your Email</label>
                <input
                  className="form-input"
                  placeholder="Your Email"
                />
              </div>
              <div className="flex col-span-2 flex-col gap-[5px]" >
                <label className="form-label">Your Phone</label>
                <input
                  className="form-input"
                  placeholder="Your Phone"
                />
              </div>
              <div className="flex col-span-2 flex-col gap-[5px]" >
                <label className="form-label">Training Courses</label>
                <input
                  className="form-input"
                  placeholder="Training Courses"
                />
              </div>
              <div className="flex col-span-2 flex-col gap-[5px]" >
                <label className="form-label">Training Experience</label>
                <input
                  className="form-input"

                  placeholder="Training Experience"
                />
              </div>
              <div className="grid col-span-2 md:grid-cols-2 grid-cols-1 gap-[30px]">
              <div className="flex flex-col gap-[5px]">
                <label className="form-label">Linkedin Profile</label>
                <input
                  className="form-input"
                  placeholder="Enter"
                />
              </div>
              <div className="flex flex-col gap-[5px]">
                <label className="form-label">Attach Your CV Resume</label>
                <input className="form-input"
                  placeholder="Attach"
                />
              </div>
            </div>
            </div>
  
          </div>
          <div className="log-btn log-btn2">
            <button className="get1">Apply<br /><i className="bi bi-arrow-right"></i></button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default BeATrainer